export * from './gdm-page-card-footer';
export * from './gdm-page-card-header';
